import type { CatalogItem } from "@jambushrushti/data/libraryData";

interface BookRecord {
  id: string | number;
  title: string;
  author?: string | null;
  category?: string | null;
  language?: string | null;
  year?: number | null;
  cover_image_url?: string | null;
  cover_image?: string | null;
  description?: string | null;
  pdf_url?: string | null;
  audio_url?: string | null;
  is_published: boolean;
}

const baseUrl = import.meta.env.DEV
  ? "/jambushrusti-api"
  : (
      import.meta.env.VITE_API_BASE_URL ||
      "https://api.jambushusti.universal-software.in/api"
    ).replace(/\/$/, "");
const endpoint = `${baseUrl}/jambushrusti/cms/books/`;

export async function fetchLibraryBooks(
  signal?: AbortSignal
): Promise<CatalogItem[]> {
  const books: CatalogItem[] = [];
  let page = 1;
  let hasNext = true;

  while (hasNext) {
    const response = await fetch(`${endpoint}?page=${page}`, {
      signal,
      headers: {
        "X-Tenant-ID":
          import.meta.env.VITE_X_TENANTID ||
          "6cf833d7-bf6f-4688-9136-5674d8053b85",
      },
    });
    if (!response.ok) {
      throw new Error("Unable to load books. Please try again.");
    }
    const payload = await response.json();
    const data = payload.data ?? payload;
    const rows: BookRecord[] = Array.isArray(data) ? data : data.results;
    if (!Array.isArray(rows)) {
      throw new Error("The books response could not be read.");
    }

    for (const book of rows) {
      if (book.is_published === true) {
        books.push({
          id: String(book.id),
          title: book.title || "Untitled book",
          type: "Book",
          author: book.author || "Author not specified",
          category: book.category || "Uncategorized",
          language: book.language || "Not specified",
          year: book.year == null ? "Not specified" : String(book.year),
          image: book.cover_image || book.cover_image_url || "/placeholder.svg",
          description: book.description || "Description not available.",
          pdf_url: book.pdf_url || null,
          audio_url: book.audio_url || null,
          available: null,
          location: "Not specified",
          publisher: "Not specified",
          pages: null,
        });
      }
    }
    hasNext = Boolean(data.links?.next ?? data.next);
    page += 1;
  }
  return books;
}
